import {
  NBS_API_GET_CONFIG_SUCCESS
} from '../../constants/actions';

const initialState = {
  data: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_CONFIG_SUCCESS:
      return {
        ...state,
        data: action.response.happy_hour
      };
    default:
      return state;
  }
}
